module.exports = {
    development: "https://test.xinchuangquan.cn:",
    production: "https://log.yuanyuanshuju.com:",
    // production: "https://test.xinchuangquan.cn:",
};
















// WEBPACK FOOTER //
// ./src/common/conf/ServerTwo.js